import { render } from "./AddDataTable.vue?vue&type=template&id=33963f7b&scoped=true"
import script from "./AddDataTable.vue?vue&type=script&lang=js"
export * from "./AddDataTable.vue?vue&type=script&lang=js"

import "./AddDataTable.vue?vue&type=style&index=0&id=33963f7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33963f7b"]])

export default __exports__